import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M43.9 10.3817C37.49 1.94169 27.86 1.90167 25.84 1.99167C23.82 1.90167 14.18 1.94169 7.77997 10.3817C0.589972 19.8517 2.08997 39.0017 2.08997 39.0017C2.08997 39.0017 5.73997 28.6517 6.59997 21.2817C7.45997 13.9017 12.18 8.51169 16.68 7.41169C20.76 6.41169 21.97 8.49167 25.84 8.49167C29.71 8.49167 30.92 6.41169 35 7.41169C39.51 8.51169 44.23 13.9117 45.08 21.2817C45.94 28.6617 49.59 39.0017 49.59 39.0017C49.59 39.0017 51.08 19.8517 43.9 10.3817Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
